import { render, staticRenderFns } from "./AppHeaderVehicleSearch.vue?vue&type=template&id=bbc8cd9a&"
import script from "./AppHeaderVehicleSearch.vue?vue&type=script&lang=js&"
export * from "./AppHeaderVehicleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports